module.exports = __webpack_public_path__ + "school/img/childrenCultureBg.4ca67e1a.jpg";